<template>
  <div class="container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="col-md-8 offset-md-2">
            <h5 class="card-title">Agregar nuevo proveedor</h5>
            <b-form @submit.stop.prevent="onSubmit">
              <b-form-group label-cols-sm="2" label="Nombre*" label-for="input-name">
                <b-form-input
                  id="input-name"
                  name="input-name"
                  type="text"
                  v-model="$v.form.name.$model"
                  :state="validateState('name')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-name-live-feedback"
                >El nombre es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Codigo*" label-for="input-clave">
                <b-form-input
                  id="input-clave"
                  name="input-clave"
                  type="text"
                  v-model="$v.form.clave.$model"
                  :state="validateState('clave')"
                ></b-form-input>
                <b-form-invalid-feedback id="input-clave-live-feedback">La clave es requerida.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Siglas*" label-for="input-clave">
                <b-form-input
                  id="input-clave"
                  name="input-clave"
                  type="text"
                  placeholder=""
                  v-model="$v.form.siglas.$model"
                  :state="validateState('siglas')"
                ></b-form-input>
                <b-form-invalid-feedback id="input-clave-live-feedback">La clave es requerida.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Descuento*" label-for="input-discount">
                <b-form-input
                  id="input-discount"
                  name="input-discount"
                  type="text"
                  v-model="$v.form.discount.$model"
                  :state="validateState('discount')"
                ></b-form-input>
                <b-form-invalid-feedback id="input-discount-live-feedback">El descuento es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Descuento al cliente*" label-for="input-cliet-discount">
                <b-form-input
                  id="input-cliet-discount"
                  name="input-cliet-discount"
                  type="text"
                  v-model="$v.form.clientDiscount.$model"
                  :state="validateState('clientDiscount')"
                ></b-form-input>
                <b-form-invalid-feedback id="input-cliet-discount-live-feedback">El descuento al cliente es requerido.</b-form-invalid-feedback>
              </b-form-group>

               <b-form-group label-cols-sm="2" label="Calculo de Precio*" label-for="input-cliet-discount">
                <b-form-checkbox v-model="form.right" name="check-button" switch>
                   Calculo hacia la  <b>{{ form.right ? 'Derecha' : 'Izquierda'}}</b>
                </b-form-checkbox>
              </b-form-group>

              <div class="form-group row mt-5">
                <div class="col-sm-12">
                  <b-button type="submit" variant="primary" block>Agregar Proveedor</b-button>
                </div>
              </div>

            </b-form>
          </div>
        </div>
      </div>
    </div>
    <modal name="modalDates" :adaptive="true" :scrollable="true" height="550" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('modalDates')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass">
        <h2>Detalle de inventario </h2>
      </div>
    </modal>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import mexicosStatesList from '@/mixins/mexicosStatesList'
import mexicoCitiesList from '@/mixins/mexicoCitiesList'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import formatData from '@/mixins/formatAxios'
import {
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  // BFormSelect,
  BFormCheckbox,
  BFormInvalidFeedback
} from 'bootstrap-vue'

export default {
  mixins: [validationMixin, formatData],
  components: {
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormCheckbox
    // BFormSelect
  },
  data () {
    return {
      form: {
        right: true,
        name: '',
        clientDiscount: 0,
        discount: 0,
        clave: '',
        siglas: ''
      },
      stateObject: { name: '', code: '' },
      cityObject: { name: '', id: '' },
      mexicosStatesList: mexicosStatesList,
      mexicoCitiesList: mexicoCitiesList
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      clave: {
        required
      },
      discount: {
        required
      },
      clientDiscount: {
        required
      },
      siglas: {
        required
      }
    }
  },
  methods: {
    showError (msg) {
      this.$toastedPush({
        message: msg,
        type: 'error'
      })
    },
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async onSubmit () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }
        const request = {
          clave: this.form.clave,
          name: this.form.name,
          balance: this.form.balance,
          discount: this.form.discount,
          discount_client: this.form.clientDiscount,
          right: this.form.right ? 1 : 0,
          siglas: this.form.siglas
        }
        const response = await axiosAdelaService.post('/addProvider', request)
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Se actualizo la información correctamente.',
            type: 'success'
          })
          this.$router.push({ name: 'providers' })
        }
      } catch (error) {
        this.showError('No se pudo agregar la empresa, intentalo mas tarde')
      }
    },
    async ShowDetail (...args) {
      this.$modal.show('modalDates')
    }
  },
  computed: {
    state: function () {
      return this.stateObject.name
    },
    city: function () {
      return this.cityObject.name
    }
  },
  watch: {
    state (state) {
      this.mexicoCitiesList = this.$_.filter(mexicoCitiesList, ['stateId', this.stateObject.id])
    }
  }
}
</script>

<style>

</style>
